import React from 'react'
import { t } from '../i18n'

export default function ConnectionBanner({ kind, locale, onDismiss }) {
  if (!kind) return null
  const isPaused = kind === 'paused'
  return (
    <div
      role="status"
      className={
        'fixed inset-x-4 top-20 z-30 mx-auto max-w-md rounded-2xl border px-4 py-3 text-sm shadow-lg ' +
        (isPaused
          ? 'border-amber-200 bg-amber-50 text-amber-900'
          : 'border-emerald-200 bg-emerald-50 text-emerald-900')
      }
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 text-base" aria-hidden>
          {isPaused ? '⏸️' : '🟢'}
        </div>
        <div className="flex-1">
          {isPaused ? (
            <>
              <div className="font-medium">{t(locale, 'pausedTitle')}</div>
              <div className="mt-0.5 text-xs opacity-90">{t(locale, 'pausedBody')}</div>
            </>
          ) : (
            <div>{t(locale, 'resumed')}</div>
          )}
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className="-mr-1 -mt-1 rounded p-1 text-xs opacity-70 hover:opacity-100"
          aria-label="dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  )
}
